import type React from "react";
import {createContext, useCallback, useMemo, useState} from "react";

export interface ErrorContextType {
    onRefresh?: () => Promise<unknown>;
    updateOnRefresh: (onRefesh: () => Promise<unknown>) => void;
}

const defaultValue: ErrorContextType = {
    updateOnRefresh: () => undefined
};

export const ErrorContext = createContext<ErrorContextType>(defaultValue);

export const ErrorConsumer = ErrorContext.Consumer;

const ErrorProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [value, setValue] = useState<ErrorContextType>(defaultValue);

    const updateOnRefresh = useCallback((onRefresh: () => Promise<unknown>) => {
        setValue(prev => ({...prev, onRefresh}));
    }, []);

    const nextValue = useMemo(
        () => ({
            ...value,
            updateOnRefresh
        }),
        [updateOnRefresh, value]
    );

    return <ErrorContext.Provider value={nextValue}>{children}</ErrorContext.Provider>;
};

export default ErrorProvider;
